/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Insurance/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import InsuranceCode from './InsuranceCode/index'
import MakePrimaryAction from './MakePrimaryAction/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import Subscription from './Subscription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Insurance({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance"
  
}) {
let insuranceItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'insurance_item',
path: 'isFirst',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Insurance.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2s0C3T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-2-2s0C3T': insuranceItemIsFirstValueData ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Subscription
  viewPath={`${viewPath}/Subscription`}
/>
<InsuranceCode
  viewPath={`${viewPath}/InsuranceCode`}
/>
<MakePrimaryAction
  viewPath={`${viewPath}/MakePrimaryAction`}
/>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
{children}
</React.Fragment>)
}